"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var Http_service_1 = require("./http/Http.service");
var typedi_1 = require("typedi");
var rxjs_1 = require("rxjs");
var TenantService = /** @class */ (function () {
    function TenantService(httpService) {
        this.httpService = httpService;
        this.onTenantInitializedSubject = new rxjs_1.ReplaySubject();
        this.isInitializingTenantInfo = false;
        this.onTenantInitialized = this.onTenantInitializedSubject.asObservable();
    }
    /**
     * Initialize tenant info by domain
     *
     * @param domain can be custom domain(eg. smc.ibm.com) or tenant domain(ibm.seismic.com)
     * @returns
     */
    TenantService.prototype.initTenantInfoByDomain = function (domain) {
        return __awaiter(this, void 0, void 0, function () {
            var url, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        this.isInitializingTenantInfo = true;
                        url = "https://service-discovery.seismic.com/api/sds/v1/tenants/domain/".concat(domain);
                        _a = this;
                        return [4 /*yield*/, this.httpService.get(url)];
                    case 1:
                        _a.tenantInfo = _b.sent();
                        this.onTenantInitializedSubject.next(this.tenantInfo);
                        this.isInitializingTenantInfo = false;
                        return [2 /*return*/, this.tenantInfo];
                    case 2:
                        error_1 = _b.sent();
                        this.isInitializingTenantInfo = false;
                        console.log(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @deprecated we are retiring this way, please use initTenantInfoByDomain() instead
     *
     * @param subdomain
     * @returns
     */
    TenantService.prototype.initTenantInfo = function (subdomain) {
        return __awaiter(this, void 0, void 0, function () {
            var url, instance, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        this.isInitializingTenantInfo = true;
                        url = "https://service-discovery.seismic.com/api/sds/v1/tenants/subdomain/".concat(subdomain);
                        instance = typedi_1.Container.get('instance');
                        if (instance.getSubdomain() !== 'subdomain')
                            instance.setSubdomain(subdomain);
                        _a = this;
                        return [4 /*yield*/, this.httpService.get(url)];
                    case 1:
                        _a.tenantInfo = _b.sent();
                        this.onTenantInitializedSubject.next(this.tenantInfo);
                        this.isInitializingTenantInfo = false;
                        return [2 /*return*/, this.tenantInfo];
                    case 2:
                        error_2 = _b.sent();
                        this.isInitializingTenantInfo = false;
                        console.log(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TenantService.prototype, "isInitializing", {
        get: function () {
            return this.isInitializingTenantInfo;
        },
        enumerable: false,
        configurable: true
    });
    TenantService.prototype.initTenantInfoByCache = function (tenantInfo) {
        this.tenantInfo = tenantInfo;
        return this.tenantInfo;
    };
    TenantService.prototype.getTenantInfo = function () {
        if (!this.tenantInfo) {
            console.error('Tenant info is not initialized. You should ask the bundle level to initialize it. Ref https://seismic.atlassian.net/browse/FEARCH-995');
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.tenantInfo;
    };
    // This is the key method to get the tenant domain
    TenantService.prototype.getDomain = function () {
        var _a, _b, _c, _d;
        return ((_a = this.getTenantInfo()) === null || _a === void 0 ? void 0 : _a.tenantCustomDomain)
            || ((_b = this.getTenantInfo()) === null || _b === void 0 ? void 0 : _b.tenantDomain)
            || (((_c = this.getTenantInfo()) === null || _c === void 0 ? void 0 : _c.tenantSubdomain) ? "".concat((_d = this.getTenantInfo()) === null || _d === void 0 ? void 0 : _d.tenantSubdomain, ".seismic.com") : '');
    };
    TenantService.prototype.getTenantName = function () {
        var _a;
        return (_a = this.getTenantInfo()) === null || _a === void 0 ? void 0 : _a.tenantName;
    };
    TenantService.prototype.getTenantUniqueId = function () {
        var _a;
        return (_a = this.getTenantInfo()) === null || _a === void 0 ? void 0 : _a.tenantUniqueId;
    };
    // Notice, you probably don't need to use this method, use `getDomain()` instead
    TenantService.prototype.getTenantCustomDomain = function () {
        var _a;
        return (_a = this.getTenantInfo()) === null || _a === void 0 ? void 0 : _a.tenantCustomDomain;
    };
    // Notice, you probably don't need to use this method, use `getDomain()` instead
    TenantService.prototype.getTenantSubdomain = function () {
        var _a;
        return (_a = this.getTenantInfo()) === null || _a === void 0 ? void 0 : _a.tenantSubdomain;
    };
    // Notice, you probably don't need to use this method, use `getDomain()` instead
    TenantService.prototype.getTenantDomain = function () {
        var _a;
        return (_a = this.getTenantInfo()) === null || _a === void 0 ? void 0 : _a.tenantDomain;
    };
    TenantService.prototype.getEnvironment = function () {
        var _a;
        return (_a = this.getTenantInfo()) === null || _a === void 0 ? void 0 : _a.environment;
    };
    TenantService.prototype.getHistorySubdomains = function () {
        var _a;
        return (_a = this.getTenantInfo()) === null || _a === void 0 ? void 0 : _a.historySubdomains;
    };
    TenantService = __decorate([
        (0, CommonService_decorator_1.CommonService)('TenantService'),
        __metadata("design:paramtypes", [Http_service_1.HttpService])
    ], TenantService);
    return TenantService;
}());
exports.TenantService = TenantService;
//# sourceMappingURL=Tenant.service.js.map